export const APP_TEXT_ES = {
  home: {
    pageTitle: 'Inicio',
    languageTitle: 'Idioma',
    languageDialogTitle: 'Selecciona el idioma que deseas cambiar:',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLanguageButton: 'Change language',
    editProfile: 'Editar perfil',
    myProfile: 'Mi perfil',
    changePassword: 'Cambiar contraseña',
    welcomeToTitle: 'Bienvenido a',
    scanEnclosureButton: 'Escanear recinto',
    searchFiltersTitle: 'Filtros de búsqueda',
    selectedEnclosureLabel: 'Recinto seleccionado',
    enclosureLabel: 'Recinto',
    selectEnclosureHint: 'Selecciona un recinto',
    allEnclosuresOption: 'Todos los recintos',
    noPurchasedTicketsText: 'Ups, aún no tienes boletos adquiridos.',
    noPurchasedTicketsHelpText: 'Selecciona tu recinto preferido y adquiere tus accesos de estacionamiento de forma anticipada.',
    buyTicketsButton: 'Comprar Boletos',
    prepaidTitle: 'Prepago',
    ticketsTitle: 'Boletos',
    balanceLabel: 'Saldo',
    reloadButton: 'Recargar',
    dateLabel: 'Fecha',
    qrTitle: 'QR',
    closeButton: 'Cerrar',
    loadBalanceTitle: 'Recargar saldo',
    emailLabel: 'Correo electrónico',
    balanceToLoadLabel: 'Saldo a cargar',
    cancelButton: 'Cancelar',
    goToPaymentButton: 'Ir al pago',
    acceptButton: 'Aceptar',
    errorTitle: 'Error',
    genericErrorMessage: 'Lo sentimos, ha ocurrido un error.',
    qrErrorMessage: 'Lo sentimos, ha ocurrido un error al obtener el QR.',
    balanceRequiredMessage: 'Debes ingresar el saldo.',
    userAvatarAlt: 'Avatar del usuario',
    homeHeroAlt: 'Vista principal de inicio',
    homeHeroMobileAlt: 'Vista principal de inicio en formato vertical',
    qrIconAlt: 'Código QR',
    modalQrImageAlt: 'Imagen del código QR',
    logoAlt: 'Logo de Parkit',
  },
  sidebar: {
    helloPrefix: '¡Hola',
    editProfile: 'Editar mi perfil',
    myProfile: 'Mi Perfil',
    changePassword: 'Cambiar contraseña',
    closeSession: 'Cerrar sesión',
    notificationAction: 'Acción',
    notificationAnotherAction: 'Otra acción',
    notificationSomethingElse: 'Otra opción',
    home: 'Inicio',
    qrSection: 'QR',
    qrScanner: 'Scanner QR',
    eventsSection: 'Eventos',
    eventsQuery: 'Consulta de eventos',
    buyTicketsSection: 'Comprar boletos',
    selectEnclosure: 'Selecciona tu recinto',
    myTickets: 'Mis boletos',
    vehicles: 'Vehículos',
    salesSection: 'Ventas',
    eventReports: 'Reporte eventos',
    userReports: 'Reportes Usuarios',
    vipZoneReports: 'Reportes de zonas VIP',
    prepaidUserReports: 'Reportes de Usuarios Prepago',
    careAccountReport: 'Reporte Estado Cuenta CARE',
    vipStatusReport: 'Reporte Estado VIP',
    reportByMonth: 'Reporte por mes',
    reportClosingMonth: 'Reporte cierre de mes',
    adminSection: 'Administración',
    users: 'Usuarios',
    zones: 'Zonas',
    enclosures: 'Recintos',
    localities: 'Localidades',
    parkingZone: 'Zona de estacionamiento',
    eventTypes: 'Tipos de evento',
    discountCode: 'Código de descuento',
    disclaimers: 'Disclaimers',
    qrGeneration: 'Generacion de QR',
    qrSubscribers: 'QR Abonados',
    parkingPensConfig: 'Configuración de plumas',
    prepaidSection: 'Prepago',
    prepaidTypes: 'Tipos de prepago',
    createNewProfile: 'Dar de alta nuevo perfil',
    prepaidUsersAdminSection: 'Administración de usuarios prepago',
    registerQrs: "Dar de alta QR's",
    changeQrType: 'Cambiar tipo de QR',
    subscribersSection: 'Abonados',
    subscriberList: 'Lista de Abonados',
    walletSection: 'Ver wallet',
    wallet: 'Wallet',
    consultReloadQr: 'Consultar/Recargar QR',
    movementHistory: 'Historial',
    partners: 'Socios Parkit',
    scanEnclosure: 'Escanear recinto',
    languageTitle: 'Idioma',
    langSpanish: 'Español',
    langEnglish: 'English',
    logoutButton: 'Cerrar Sesión',
  },
  footer: {
    rightsReserved: 'Todos los derechos reservados',
    termsTitle: 'TÉRMINOS Y CONDICIONES',
    closeButton: 'Cerrar',
  },
  header: {
    home: 'Inicio',
    selectEnclosure: 'Selecciona el recinto',
    buyParkingSpot: 'COMPRAR LUGAR DE ESTACIONAMIENTO',
    prepaid: 'Prepago',
    logoAlt: 'Logo',
    helloPrefix: '¡Hola',
    userFallback: 'usuario',
    openProfileMenu: 'Abrir menú de perfil',
    myProfile: 'Mi perfil',
    changePassword: 'Cambiar contraseña',
    closeSession: 'Cerrar sesión',
  },
  loaders: {
    loadingGeneric: 'Cargando',
    loadingSrOnly: 'Cargando...',
    loadingResources: 'Cargando recursos',
    loadingReportTitle: 'Cargando Reporte',
    loadingReport: 'Cargando reporte...',
    loadingData: 'Cargando datos...',
    loadingZonesTitle: 'Cargando zonas',
    loadingZones: 'Cargando zonas...',
    loadingSchedules: 'Cargando horarios...',
    loadingEventsTitle: 'Cargando Eventos',
    loadingEventsPreloader: 'Cargando eventos',
    loadingEvents: 'Cargando eventos...',
    loadingMessages: 'Cargando mensajes...',
    loadingTicketInfo: 'Cargando información del boleto...',
    loadingAvailableParkingZone: 'Cargando tu zona de estacionamiento disponible',
    loadingPartners: 'Cargando socios...',
    loadingUserTitle: 'Cargando Usuario',
    loadingUsersTitle: 'Cargando Usuarios',
    loadingTicketsTitle: 'Cargando Boletos',
    loadingSubscribersTitle: 'Cargando Abonados',
    loadingParkingZones: 'Cargando zonas de estacionamiento...',
    loadingInfo: 'Cargando información...',
    loadingAvailableZones: 'Cargando zonas disponibles...',
    loadingMap: 'Cargando mapa...',
  },
  locality: {
    pageTitle: 'Selecciona tu ciudad',
    headerTitle: 'Selecciona tu ciudad',
    searchPlaceholder: 'Buscar ciudad o recinto...',
    clearSearchButton: 'Limpiar búsqueda',
    resultFoundSingular: 'resultado encontrado',
    resultsFoundPlural: 'resultados encontrados',
    loadingSrOnly: 'Cargando...',
    loadingCities: 'Buscando ciudades...',
    viewEnclosuresButton: 'Ver Recintos',
    citiesSection: 'Ciudades',
    enclosuresSection: 'Recintos',
    viewEventsButton: 'Ver Eventos',
    viewDetailsButton: 'Ver Detalles',
    viewWalletButton: 'Ver Wallet',
    buyTicketsButton: 'Comprar Boletos',
    noResultsTitle: 'Sin resultados para',
    noResultsMessage: 'Intenta con otro nombre de ciudad o recinto',
    emptyLocalitiesTitle: 'No encontramos localidades disponibles',
    emptyLocalitiesMessage: 'Intenta recargar la página más tarde',
    allLocalitiesOption: 'Todas las localidades',
    allLocalitiesSelectedCityName: 'México',
  },
  enclosureByLocality: {
    pageTitle: 'Recintos por localidad',
    cityImageAlt: 'Ciudad',
    heroTitlePrefix: 'Explora',
    heroSubtitle: 'Descubre los mejores eventos y lugares en tu ciudad',
    searchPlaceholder: 'Buscar recinto...',
    clearSearchButton: 'Limpiar búsqueda',
    resultFoundSingular: 'recinto encontrado',
    resultsFoundPlural: 'recintos encontrados',
    loadingSrOnly: 'Cargando...',
    viewEventsButton: 'Ver Eventos',
    viewDetailsButton: 'Ver Detalles',
    viewWalletButton: 'Ver Wallet',
    buyTicketsButton: 'Comprar Boletos',
    noResultsTitle: 'Sin resultados para',
    noEnclosuresInCityMessage: 'No se encontraron recintos en {city}.',
    backToLocalitiesButton: 'Volver a Localidades',
    allLocalitiesSelectedCityName: 'México',
    selectedCityFallback: 'esta ciudad',
  },
  salesUsers: {
    pageTitle: 'Compra de boleto',
    cartTitle: 'Mi carrito',
    emptyCartTitle: 'Tu carrito está vacío',
    emptyCartMessage: 'Explora los eventos y agrega boletos para comenzar.',
    viewEventsButton: 'Ver Eventos',
    roundTripLabel: 'Tu compra contiene tu boleto de ida y vuelta',
    ticketsIncludedLabel: 'boletos incluidos',
    removeButtonLabel: 'Eliminar',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Cargo por servicio',
    totalLabel: 'Total',
    addMoreButton: 'Agregar más',
    payNowButton: 'Pagar ahora',
    cancelButton: 'Cancelar',
    logoAlt: 'Logo de Parkit',
    selectModeTitle: 'Selecciona una de las siguientes opciones.',
    eventsModeButton: 'Eventos',
    prepaidModeButton: 'Prepago',
    subscribersModeButton: 'Abonados',
    allInOneEyebrow: 'Compra boletos',
    allInOneTitle: 'Elige cómo quieres llegar al evento',
    allInOneSubtitle: 'Selecciona una opción para continuar con tu compra.',
    allInOneParkingButton: 'Estacionamiento',
    allInOneParkingDescription: 'Reserva tu lugar de estacionamiento para el evento.',
    allInOneTransportButton: 'Transporte',
    allInOneTransportDescription: 'Compra tu traslado y viaja sin preocuparte por manejar.',
    allInOneBundleButton: 'Transporte y Estacionamiento',
    allInOneBundleDescription: 'Combina ambos servicios en una sola experiencia.',
    carTypeLabel: 'Tipo de automóvil:',
    selectedCarLabel: 'Automóvil seleccionado:',
    selectCarTypePlaceholder: 'Selecciona tu tipo de automóvil',
    noEventsAlert: 'Lo sentimos, aún no tenemos eventos para este recinto.',
    eventLabel: 'Evento:',
    swipeForMore: 'Desliza para ver más',
    selectedEventLabel: 'Evento seleccionado:',
    selectEventPlaceholder: 'Selecciona un evento',
    loadingSrOnly: 'Cargando...',
    loadingParking: 'Cargando estacionamientos...',
    availableParkingLabel: 'Estacionamientos disponibles',
    busSchedulesLabel: 'Horarios de autobuses',
    zoneLabel: 'Zona',
    busLabel: 'Autobús',
    scheduleLabel: 'Horario',
    selectZonePlaceholder: 'Selecciona una zona',
    loadingAddress: 'Cargando dirección...',
    addressLabel: 'Dirección',
    referenceLabel: 'Referencia',
    passengersLabel: 'Pasajeros',
    ticketsLabel: 'Boletos',
    oneTicketLabel: '1 boleto',
    singleSelectionLabel: 'Selección única',
    numberOfTicketsLabel: 'Número de boletos',
    numberOfPassengersLabel: 'Número de pasajeros',
    tripTypeLabel: 'Tipo de viaje',
    roundTripTripOption: 'Redondo (ida y vuelta)',
    oneWayTripIdaOption: 'Sencillo (solo ida)',
    oneWayTripVueltaOption: 'Sencillo (solo vuelta)',
    bundleTripNote: 'Estacionamiento incluido: el viaje de ida y vuelta es obligatorio.',
    maxPerCartWarning: 'Puedes comprar hasta 10 lugares por carrito de compra',
    eventDetailsTitle: 'Detalles del evento',
    eventSummaryLabel: 'Evento',
    dateSummaryLabel: 'Fecha',
    priceSummaryLabel: 'Precio',
    availableSummaryLabel: 'Disponibles',
    importantInfoTitle: 'Información importante',
    acceptTermsPrefix: 'He leído y acepto los',
    acceptTermsShort: 'Aceptar los',
    termsAndConditions: 'Términos y Condiciones',
    dataTitle: 'DATOS',
    availablePlacesLabel: 'Lugares disponibles',
    clearButton: 'Limpiar',
    getFreeTicketButton: 'Obtener boleto gratis',
    getTicketsButton: 'Obtener boletos',
    addToCartButton: 'Agregar al carrito',
    prepaidTitle: 'Prepago',
    prepaidEyebrow: 'Pase Digital',
    prepaidDescription: 'Obtén tu código QR prepago para acceder de forma ágil y segura al estacionamiento.',
    prepaidBenefitQrTitle: 'Código QR Único',
    prepaidBenefitQrDesc: 'Acceso directo a las barreras del recinto sin tickets de papel.',
    prepaidBenefitBalanceTitle: 'Saldo Recargable',
    prepaidBenefitBalanceDesc: 'Recarga tu monedero digital cuando lo necesites.',
    prepaidBenefitFastTitle: 'Sin Filas ni Esperas',
    prepaidBenefitFastDesc: 'Entrada y salida automatizada en tu visita.',
    prepaidReminder: 'Recuerda leer los términos y condiciones para generar tu boleto',
    generatePrepaidQrButton: 'Generar QR Prepago',
    subscribersTitle: 'Abonados',
    selectSubscriberLabel: 'Selecciona el abonado que deseas comprar:',
    selectSubscriberPlaceholder: 'Seleccione un abonado',
    loadingDetails: 'Cargando detalles...',
    subscriberLabel: 'Abonado',
    startDateLabel: 'Fecha de Inicio',
    endDateLabel: 'Fecha Final',
    viewIncludedEventsButton: 'Ver todos los eventos incluidos',
    buySubscriberButton: 'Comprar Abonados',
    purposeText: 'Nuestro propósito es mejorar la experiencia en los eventos presenciales.',
    mapAlt: 'Mapa o logo del recinto',
    loadingAvailableParkingZone: 'Cargando zona de estacionamiento disponible',
    locateMeTooltip: 'Ver mi ubicación',
    loadingLocation: 'Cargando ubicación...',
    mapLoadError: 'No se pudo cargar el mapa.',
    changeEnclosureButton: 'Cambiar recinto',
    alertModalTitle: '¡Disculpe!',
    acceptButton: 'Aceptar',
    confirmationBadge: 'Confirmación',
    processReadyTag: 'Proceso listo para continuar',
    reviewPurchaseTag: 'Revisa y confirma tu compra',
    continueButton: 'Continuar',
    prepaidSuccessTitle: '¡Hola {user}!',
    prepaidSuccessMessage: '¡Boleto prepago adquirido con éxito!',
    includedEventsModalTitle: 'Eventos incluidos en este abonado',
    closeButton: 'Cerrar',
    carTypeLabels: {
      compact: 'Compacto',
      sedan: 'Sedán / Coupé',
      suv: 'SUV',
      pickup: 'Camioneta',
      hybrid: 'Híbrido / Eléctrico',
      bus: 'Autobús',
      passengers: 'Pasajeros',
    },
    ticketTypeLabels: {
      departure: 'Ida',
      return: 'Vuelta',
    },
    busScheduleFormat: 'Ida: {departure} → Regreso: {return}',
    locationTimeoutError: 'Se agotó el tiempo para obtener tu ubicación.',
    locationUnavailableError:
      'La ubicación no está disponible actualmente. El dispositivo reportó un problema.',
    locationPermissionError: 'No tenemos permiso para acceder a tu ubicación.',
    locationGenericError: 'Ocurrió un error al obtener tu ubicación: {error}',
    availableParkingFallback: 'Estacionamiento disponible',
    myLocationPopup: 'Tu ubicación',
    removeRoundTripMessage:
      'Se eliminarán los boletos de ida y vuelta{event} de tu carrito. Podrás agregarlos nuevamente si aún hay disponibilidad.',
    removeSingleMessage:
      '¿Deseas eliminar este boleto{event} de tu carrito? Podrás agregarlo nuevamente si aún hay disponibilidad.',
    removeTicketsTitle: 'Eliminar boletos',
    removeTicketTitle: 'Eliminar boleto',
    keepButton: 'Conservar',
    deleteButton: 'Eliminar',
    cartNotFoundError: 'No se encontró el carrito activo para eliminarlo.',
    cartUserNotFoundError: 'No se pudo identificar el usuario del carrito.',
    cartTicketsNotFoundError: 'No se pudieron identificar los boletos a eliminar.',
    deleteReturnTicketError: 'No se pudo eliminar el boleto de vuelta del carrito.',
    deleteDepartureTicketError: 'No se pudo eliminar el boleto de ida del carrito.',
    loadCartUserMissingError:
      'No se pudo cargar tu carrito porque no se identificó al usuario.',
    loadCartError: 'No se pudo cargar el carrito.',
    insufficientZonePlacesError:
      'Lo sentimos, no es posible adquirir {count} lugar(es) en esta zona.',
    successTitle: 'Éxito',
    ticketsGeneratedSuccess: 'Boletos generados correctamente',
    ticketGeneratedSuccess: 'Boleto generado correctamente',
    unknownError: 'Error desconocido',
    errorTitle: 'Error',
    noSchedulePlacesError: 'Lo sentimos, no hay lugares disponibles en este horario.',
    insufficientZonePurchaseError:
      'Lo sentimos, no es posible adquirir {count} lugar(es) en esta zona; te invitamos a revisar otras opciones o disminuir la cantidad.',
    soldOutZoneError:
      'Lo sentimos, no es posible adquirir la cantidad de boletos elegidos en esta zona porque se han agotado. Te invitamos a revisar otras zonas.',
    zoneUnavailableError:
      'Lamentamos las molestias ocasionadas; por el momento no es posible comprar boletos en esta zona. Te sugerimos intentar más tarde.',
    cartCapacityError:
      'Lo sentimos, no es posible adquirir {count} lugar(es), ya que la capacidad restante de tu carrito es de {available}.',
    cartAddedMessage:
      'A partir de este momento, dispondrás de 15 minutos para completar tu transacción; de lo contrario, los boletos serán liberados.',
    cartAddedTitle: '¡Se añadió al carrito!',
    deleteTicketError: 'No se pudo eliminar el boleto del carrito.',
    emptyCartError: 'No se pudo vaciar el carrito.',
    termsRequiredError: 'Debes aceptar los términos y condiciones para continuar',
    termsModalTitle: 'Términos y condiciones',
    alertTitle: 'Aviso',
    mustAcceptTermsToBuy: 'Debes aceptar los términos y condiciones para comprar',
    alertCancelButton: 'Cancelar',
    subscribersLoadError: 'No se pudieron cargar los suscriptores del usuario',
    subscriberDetailsLoadError: 'No se pudieron cargar los detalles del abonado',
    warningTitle: 'Advertencia',
    selectSubscriberWarning: 'Por favor selecciona un abonado',
    selectedSubscriberDetailsNotFound:
      'No se encontraron detalles del abonado seleccionado',
    selectedSubscriberNotFound: 'No se pudo encontrar el abonado seleccionado',
    subscriberAssignedSuccess: 'Abonado asignado correctamente al usuario',
    assignSubscriberError: 'Error al asignar el abonado',
    unexpectedServerResponse: 'Respuesta inesperada del servidor',
    unknownAssignSubscriberError: 'Error desconocido al asignar el abonado',
    infoTitle: 'Información',
    noEventsForSubscriber: 'No hay eventos disponibles para este abonado',
  },
  buyingTickets: {
    // Cart panel
    cartTitle: 'Mi Carrito',
    cartEmpty: 'Tu carrito está vacío',
    cartEmptyHint: '¡Agrega boletos para comenzar!',
    roundTripLabel: 'Tu compra contiene tu boleto de ida y vuelta',
    ticketsIncludedLabel: 'boletos incluidos',
    removeButton: 'Eliminar',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Cargo por servicio',
    totalLabel: 'Total',
    addMoreButton: 'Agregar más',
    payNowButton: 'Pagar Ahora',
    // Confirm modal
    confirmationBadge: 'Confirmación',
    requestProcessedTag: 'Tu solicitud fue procesada',
    continueNextStepTag: 'Continúa con el siguiente paso',
    continueButton: 'Continuar',
    ticketAcquiredTitle: '¡Boleto adquirido!',
    eventTicketGeneratedSuccess: 'Tu boleto de evento ha sido generado exitosamente.',
    cartAddedTitle: '¡Se añadió al carrito!',
    cartAddedMessage: 'A partir de este momento, dispondrá de 15 minutos para completar su transacción, de lo contrario los boletos serán liberados.',
    // Incomplete purchase alert
    dearUserPrefix: 'Estimado',
    thankYouForPurchase: '¡Gracias por tu compra!',
    incompletePurchaseNote: 'No olvides adquirir los boletos que te falten de (estacionamiento o autobús) para poder llegar al recinto.',
    eventLabel: 'Evento:',
    missingBusTicket: 'Falta boleto de autobús',
    personInCar: 'persona en el auto',
    personsInCar: 'personas en el auto',
    busTicketsLabel: 'boletos para autobús',
    missingParkingTicket: 'Falta boleto de estacionamiento',
    withBusLabel: 'con autobús',
    withParkingLabel: 'con estacionamiento',
    recommendAcquirePrefix: 'Te recomendamos adquirir',
    busTicketSingularLabel: 'boleto de autobús',
    busTicketPluralLabel: 'boletos de autobús',
    parkingTicketSingularFor: 'boleto de estacionamiento para',
    parkingTicketPluralFor: 'boletos de estacionamiento para',
    buyBusButton: 'Comprar autobús',
    buyParkingButton: 'Comprar estacionamiento',
    skipButton: 'Omitir',
    missingEventTicket: 'Falta boleto de evento',
    missingBothTickets: 'Faltan boleto de evento y autobús',
    // Error alert
    sorryLabel: 'Lo sentimos',
    closeButton: 'Cerrar',
    genericError: 'Ha ocurrido un error.',
    ticketAcquireError: 'Ha ocurrido un error al adquirir el boleto.',
    ticketsCreationError: 'No se pudieron crear los boletos. Intente nuevamente.',
    // Buy event mode (parking ticket)
    buyParkingBadge: 'Comprar boleto de estacionamiento',
    selectTicketTitle: 'Selecciona tu boleto',
    carEventZoneSubtitle: 'Elige tu tipo de auto, evento y zona de estacionamiento',
    carTypeLabel: 'Tipo de automóvil',
    selectedCarLabel: 'Automóvil seleccionado',
    noEventsAvailable: 'No hay eventos disponibles para este recinto.',
    selectedEventLabel: 'Evento seleccionado',
    enclosureLocationLabel: 'Ubicación del recinto',
    parkingBoardLabel: 'Estacionamiento al que te vas a subir',
    passengersInCarQuestion: '¿Cuántos pasajeros dentro del auto a estacionar?',
    addressLabel: 'Dirección',
    referenceLabel: 'Referencia',
    priceLabel: 'Precio',
    freeLabel: 'Gratis',
    availableLabel: 'Disponibles',
    acceptTermsPrefix: 'He leído y acepto los',
    termsAndConditions: 'Términos y Condiciones',
    processingLabel: 'Procesando...',
    noAvailabilityLabel: 'Sin disponibilidad',
    acquireTicketButton: 'Adquirir Boleto',
    addToCartButton: 'Agregar al carrito',
    cancelButton: 'Cancelar',
    // Bus / multiple area mode
    buyBusBadge: 'Comprar boleto de autobús',
    yourEventIs: 'Tu evento es:',
    howManyPeopleQuestion: '¿Cuántas personas van?',
    personSingular: 'persona',
    personPlural: 'personas',
    yourParkingSpotIs: 'Tu lugar de estacionamiento es:',
    completePurchaseTitle: '¡Completa tu compra!',
    busTicketIncludesPrefix: 'Tu boleto de evento incluye',
    needToAcquirePrefix: 'Necesitas adquirir',
    boardingTransportSuffix: 'para que todos puedan abordar el transporte.',
    withoutBusTicketPrefix: 'Sin el boleto de autobús',
    cannotBoardLabel: 'no podrás abordar',
    transportServiceLabel: 'el servicio de transporte',
    selectScheduleBelow: 'Selecciona tu horario abajo y confirma tu compra',
    scheduleRegisteredTitle: '¡Horario registrado!',
    scheduleSelectedPrefix: 'Has seleccionado el horario',
    forPrefix: 'para',
    busTicketRequestedSuffix: 'Tu boleto de autobús ha sido solicitado.',
    viewMyTicketsButton: 'Ver mis boletos',
    selectBusScheduleLabel: 'Selecciona tu horario de autobús',
    returnLabel: 'Regreso:',
    howManyBusTicketsQuestion: '¿Cuántos boletos de autobús?',
    importantInfoTitle: 'Información importante',
    selectedScheduleLabel: 'Horario seleccionado',
    buyBusTicketAction: 'Comprar boleto de autobús',
    selectScheduleFirstLabel: 'Selecciona un horario primero',
    tripTypeLabel: 'Tipo de viaje',
    roundTripTripOption: 'Redondo (ida y vuelta)',
    oneWayTripIdaOption: 'Sencillo (solo ida)',
    oneWayTripVueltaOption: 'Sencillo (solo vuelta)',
    // Empty state
    noPendingTicketsTitle: 'Sin boletos pendientes',
    noIncompleteText1: 'No tienes compras incompletas en este momento.',
    noIncompleteText2: 'Explora los eventos disponibles y adquiere tus boletos.',
    chooseCityStep: 'Elige tu ciudad',
    selectEnclosureStep: 'Selecciona recinto',
    buyTicketStep: 'Compra tu boleto',
    exploreEventsButton: 'Explorar eventos',
    // Cart removal dialog
    removeTicketsTitle: 'Eliminar boletos',
    removeTicketTitle: 'Eliminar boleto',
    keepButton: 'Conservar',
    deleteButton: 'Eliminar',
    removeRoundTripMessage: 'Se eliminarán los boletos de ida y vuelta{event} de tu carrito. Podrás agregarlos nuevamente si aún hay disponibilidad.',
    removeSingleMessage: '¿Deseas eliminar este boleto{event} de tu carrito? Podrás agregarlo nuevamente si aún hay disponibilidad.',
    // Cart errors
    cartNotFoundError: 'No se encontró el carrito activo para eliminarlo.',
    cartUserNotFoundError: 'No se pudo identificar el usuario del carrito.',
    cartTicketsNotFoundError: 'No se pudieron identificar los boletos a eliminar.',
    deleteReturnTicketError: 'No se pudo eliminar el boleto de vuelta del carrito.',
    deleteDepartureTicketError: 'No se pudo eliminar el boleto de ida del carrito.',
    loadCartUserMissingError: 'No se pudo cargar tu carrito porque no se identificó al usuario.',
    emptyCartError: 'No se pudo vaciar el carrito.',
    deleteTicketError: 'No se pudo eliminar el boleto del carrito.',
    singleTicketToDeleteError: 'No se pudo identificar el boleto a eliminar.',
  },
  login: {
    pageTitle: 'Iniciar sesión',
    loginTitle: 'Iniciar sesión',
    welcomeSubtitle: 'Bienvenido',
    preloaderMessages: [
      'Preparando tu espacio...',
      'Cargando tu panel...',
      'Sincronizando accesos...',
      'Verificando permisos...',
      '¡Casi listo!',
    ],
    brandHeadlineMain: 'Tu estacionamiento,',
    brandHeadlineAccent: 'inteligente.',
    brandDesc:
      'Garantiza tu lugar con pago anticipado, evita filas y contratiempos. Desde tu celular, asegura tu espacio y disfruta tu evento sin preocupaciones.',
    firstStatNumber: 'QR',
    firstStatLabel: 'Acceso rápido',
    secondStatNumber: 'Rápido',
    secondStatLabel: 'Acceso',
    emailOption: 'Correo electrónico',
    emailOptionDesc: 'Ingresa con tu email y contraseña',
    whatsappOption: 'WhatsApp',
    whatsappOptionDesc: 'Código de verificación por celular',
    otherOptions: 'otras opciones',
    recoverPassword: 'Olvidaste tu contraseña',
    createAccount: 'Crear cuenta',
    partnerAccessTitle: 'Acceso a socios',
    partnerAccessDesc: 'Inicia sesión o únete como socio Parkit',
    emailFormTitle: 'Bienvenido',
    emailFormSubtitle: 'Ingresa con tu correo o usuario',
    emailLabel: 'Email / Nombre de usuario',
    emailPlaceholder: 'tucorreo@ejemplo.com',
    emailRequiredError:
      'Este campo es requerido, por favor ingrese su correo o usuario.',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: '••••••••',
    passwordRequiredError:
      'Este campo es requerido, por favor ingrese su contraseña.',
    enterBtn: 'Entrar',
    backBtn: 'Regresar',
    whatsappFormTitle: 'Ingreso con WhatsApp',
    whatsappFormSubtitle: 'Recibirás un código en tu celular',
    phoneLabel: 'Número de celular',
    phonePlaceholder: '10 dígitos',
    phoneRequiredError: 'Debes agregar un número celular válido.',
    phonePatternError: 'El número de celular debe tener 10 dígitos.',
    sendCodeBtn: 'Enviar código',
    verifyTitle: 'Verificación',
    verifySubtitle: 'Introduce el código enviado a tu WhatsApp',
    verifyCodeRequired: 'Debes ingresar el código completo.',
    verifyBtn: 'Verificar código',
    langDialogTitle: 'Idioma',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLang: 'Change language',
    errorDialogTitle: 'Atención',
    modalConfirmBtn: 'Entendido',
    credentialFallbackError: 'Error de credenciales',
    registerInviteError:
      'No existe una cuenta asociada a este número',
    createAccountPrompt: '¿Te gustaría crear tu cuenta?',
    modalAcceptBtn: 'Aceptar',
    modalCloseBtn: 'Cerrar',
    modalCancelBtn: 'Cancelar',
    channelSelectionTitle: '¿A dónde deseas mandar el código?',
    channelSelectionMessage:
      'Detectamos este correo asociado a tu cuenta: {email}. ¿Te gustaría recibir tu código de inicio de sesión por correo o por WhatsApp?',
    confirmEmailTitle: 'Confirmación de cuenta',
    confirmEmailMessage: 'Tu número está vinculado a la siguiente cuenta de correo:',
    confirmEmailQuestion: '¿Deseas mandar el código a tu correo o a tu WhatsApp?',
    confirmEmailBtnEmail: 'Correo',
    confirmEmailBtnWhatsapp: 'WhatsApp',
    verifyEmailSubtitle: 'Introduce el código enviado a tu correo electrónico',
    retryError: 'Error, intenta de nuevo.',
    codeRequiredError: 'Por favor, introduce el código completo.',
    invalidCodeError: 'El código ingresado no es válido.',
    userIdNotFoundError:
      'Error: no se encontró el identificador del usuario. Solicita un nuevo código.',
    codeMismatchError:
      'El código ingresado no es correcto. Por favor, verifica el código.',
    generalError: 'Ocurrió un error, vuelve a intentarlo por favor.',
    unknownError: 'Error desconocido. Por favor, intenta nuevamente.',
    codeVerificationError:
      'Te pedimos verifiques el código número ingresado, no coincide con el registro',
    invalidCredentialsError: 'El usuario y/o contraseña son incorrectos.',
    inactiveUserError: 'Usuario inactivo',
  },
  partnerLogin: {
    pageTitle: 'Acceso a socios',
    brandBadge: 'Portal de Socios',
    brandHeadlineMain: 'Bienvenido de',
    brandHeadlineAccent: 'regreso, socio.',
    brandDesc:
      'Accede a tu panel para gestionar tu estacionamiento, monitorear ingresos y controlar accesos en tiempo real.',
    featureOne: 'Reportes en tiempo real',
    featureTwo: 'Control de accesos QR',
    featureThree: 'Gestión de zonas y tarifas',
    backToHome: 'Volver al inicio',
    formTitle: 'Iniciar sesión',
    formSubtitle: 'Ingresa con tu correo o nombre de usuario',
    emailLabel: 'Correo / Usuario',
    emailPlaceholder: 'tucorreo@ejemplo.com',
    emailRequiredError: 'Este campo es requerido.',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: '••••••••',
    passwordRequiredError: 'Este campo es requerido.',
    submitButton: 'Entrar al panel',
    noAccountText: '¿Aún no tienes cuenta?',
    registerButton: 'Registrarme como socio',
    loginErrorFallback: 'Ocurrió un error al iniciar sesión.',
    invalidCredentialsError: 'Credenciales incorrectas.',
    inactiveUserError: 'Usuario inactivo',
  },
  partnerLanding: {
    pageTitle: 'Programa de socios Parkit',
    languageTitle: 'Idioma',
    langSpanish: 'Español',
    langEnglish: 'English',
    loginButton: 'Iniciar sesión',
    heroBadge: 'Programa de socios Parkit',
    heroTitleMain: 'Convierte tu espacio en un',
    heroTitleAccent: 'negocio inteligente',
    heroSubtitle:
      'Administra tu estacionamiento, vende boletos digitales y controla cada acceso con tecnología QR. Rápido, seguro y sin complicaciones.',
    heroPrimaryButton: 'Quiero ser socio',
    heroSecondaryButton: 'Conocer más',
    slides: [
      {
        icon: 'fa-qrcode',
        title: 'Acceso con QR',
        desc: 'Cada boleto genera un QR único. Tu staff lo escanea en segundos para validar el acceso.',
      },
      {
        icon: 'fa-chart-line',
        title: 'Ingresos en tiempo real',
        desc: 'Consulta ventas, ocupación y reportes del día desde cualquier dispositivo.',
      },
      {
        icon: 'fa-tags',
        title: 'Zonas y tarifas',
        desc: 'Configura zonas VIP, precios por horario y códigos de descuento en minutos.',
      },
      {
        icon: 'fa-shield-alt',
        title: 'Seguridad total',
        desc: 'QRs cifrados de un solo uso. Sin duplicados, sin fraudes, sin preocupaciones.',
      },
      {
        icon: 'fa-mobile-alt',
        title: 'Sin hardware extra',
        desc: 'Solo necesitas un celular para escanear. Sin terminales costosas ni instalaciones.',
      },
    ],
    screenScanLabel: 'Escanear acceso',
    screenSpacesLabel: 'Espacios',
    screenTodayLabel: 'Hoy',
    screenOccupiedLabel: 'Ocupado',
    heroImageAlt: 'Estacionamiento Parkit',
    heroImageBadge: 'Tu espacio, potenciado',
    statsActivePartners: 'Socios activos',
    statsTicketsSold: 'Tickets vendidos',
    statsDigital: 'Digital y sin papel',
    statsAlwaysAvailable: 'Disponible siempre',
    stepsSectionLabel: 'Proceso simple',
    stepsSectionTitle: '¿Cómo funciona?',
    stepsSectionSubtitle:
      'En tres pasos tienes tu estacionamiento operando con Parkit',
    stepsImageAlt: 'Auto entrando al estacionamiento con acceso controlado',
    stepOneTitle: 'Registra tu espacio',
    stepOneDesc:
      'Crea tu cuenta como socio, agrega tu estacionamiento y configura tus zonas y capacidad disponible.',
    stepTwoTitle: 'Vende boletos digitales',
    stepTwoDesc:
      'Tus clientes compran su lugar desde su celular. Tú decides precios, horarios y disponibilidad.',
    stepThreeTitle: 'Controla con QR',
    stepThreeDesc:
      'Al llegar, el cliente muestra su QR y tu staff lo escanea. Acceso verificado en segundos, sin papel ni filas.',
    benefitsSectionLabel: 'Por qué elegirnos',
    benefitsSectionTitleMain: 'Todo lo que necesitas,',
    benefitsSectionTitleAccent: 'en un solo lugar',
    benefitsImageAlt:
      'Persona usando su celular dentro del estacionamiento',
    benefitsImageBadge: 'Gestión móvil en tiempo real',
    benefitOneTitle: 'Reportes en tiempo real',
    benefitOneDesc:
      'Monitorea ingresos, ocupación y accesos al instante desde cualquier dispositivo.',
    benefitTwoTitle: '100% desde tu celular',
    benefitTwoDesc:
      'Gestiona todo desde la app móvil de Parkit. Sin instalar hardware costoso.',
    benefitThreeTitle: 'Accesos seguros',
    benefitThreeDesc:
      'Cada QR es único, cifrado y de un solo uso. Imposible de duplicar o falsificar.',
    benefitFourTitle: 'Zonas y precios flexibles',
    benefitFourDesc:
      'Crea zonas VIP, tarifas por horario, descuentos y abonos para clientes frecuentes.',
    benefitFiveTitle: 'Gestión de usuarios',
    benefitFiveDesc:
      'Administra a tu equipo de staff, asigna roles y permisos de acceso.',
    benefitSixTitle: 'Soporte dedicado',
    benefitSixDesc:
      'Acompañamiento desde la configuración inicial y soporte continuo para tu operación.',
    ctaImageAlt: 'Vista aérea de estacionamiento operando con Parkit',
    ctaTitle: '¿Listo para empezar?',
    ctaSubtitle:
      'Únete a cientos de estacionamientos que ya operan con Parkit. El registro es rápido y gratuito.',
    ctaPrimaryButton: 'Crear mi cuenta ahora',
    ctaLoginPrefix: '¿Ya tienes cuenta?',
    ctaLoginButton: 'Inicia sesión',
  },
  partnerRegister: {
    pageTitle: 'Registro de socios',
    brandHeadlineMain: 'Tu espacio,',
    brandHeadlineAccent: 'tu negocio.',
    brandDesc:
      'Registra tu estacionamiento en Parkit y comienza a vender boletos digitales con tecnología QR.',
    sideStepOneNumber: 'Paso 1',
    sideStepOneLabel: 'Datos de cuenta',
    sideStepTwoNumber: 'Paso 2',
    sideStepTwoLabel: 'Tu espacio',
    sideStepThreeNumber: 'Paso 3',
    sideStepThreeLabel: 'Ubicación',
    mobileStepPrefix: 'Paso',
    mobileStepConnector: 'de',
    accountTitle: 'Datos de cuenta',
    accountSubtitle: 'Crea tus credenciales de acceso a Parkit',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: 'Tu nombre de usuario',
    usernameMinLengthError: 'Mínimo 3 caracteres',
    usernamePatternError: 'Usa solo letras de A a Z y números, sin espacios ni signos.',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tucorreo@ejemplo.com',
    emailInvalidError: 'Correo inválido',
    phoneLabel: 'Número de celular',
    phonePlaceholder: '10 dígitos',
    phonePatternError: 'Debe tener 10 dígitos',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    passwordMinLengthError: 'Mínimo 8 caracteres',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repite tu contraseña',
    passwordMismatchError: 'Las contraseñas no coinciden',
    requiredFieldError: 'Campo requerido',
    nextButton: 'Siguiente',
    backButton: 'Regresar',
    previousButton: 'Anterior',
    spaceTitle: 'Tu espacio',
    spaceSubtitle: 'Cuéntanos sobre el espacio que quieres registrar',
    businessNameLabel: 'Nombre del negocio',
    optionalLabel: 'opcional',
    businessNamePlaceholder: 'Ej. Estacionamiento Central',
    spaceTypeLabel: 'Tipo de espacio físico',
    spaceTypeRequiredError: 'Selecciona un tipo de espacio',
    spaceTypes: [
      { value: 'terreno', label: 'Terreno', icon: 'fa-map' },
      {
        value: 'estacionamiento',
        label: 'Estacionamiento',
        icon: 'fa-parking',
      },
      {
        value: 'plaza_comercial',
        label: 'Plaza comercial',
        icon: 'fa-store',
      },
    ],
    capacityLabel: 'Cantidad de lugares disponibles',
    capacityPlaceholder: 'Ej. 50',
    capacityMinError: 'Debe ser al menos 1',
    multiZoneLabel: '¿Tiene más de una zona?',
    singleZoneButton: '1 Zona',
    multipleZonesButton: 'Más de una zona',
    zonesLabel: 'Número de zonas',
    zonesPlaceholder: 'Ej. 3',
    zonesMinError: 'Mínimo 2 zonas',
    locationTitle: 'Ubicación',
    locationSubtitle: '¿Dónde se encuentra tu espacio?',
    searchAddressLabel: 'Buscar dirección',
    searchAddressPlaceholder: 'Calle, colonia, ciudad...',
    addressRequiredError: 'Selecciona una ubicación en el mapa',
    locateMeTitle: 'Usar mi ubicación',
    addressLabel: 'Dirección',
    addressPlaceholder: 'Edita o escribe una dirección...',
    relocateMapTitle: 'Reubicar en mapa',
    addressHint:
      'Edita la dirección y presiona Enter (o el botón) para reubicar el pin',
    registerButton: 'Registrar mi espacio',
    alreadyHaveAccountText: '¿Ya tienes cuenta?',
    loginButton: 'Iniciar sesión',
    successTitle: '¡Primer registro enviado!',
    successMessage:
      'La primera parte del registro como socio fue recibida correctamente. Inicia sesión para continuar con tu registro.',
    successButton: 'Ir al inicio de sesión',
    errorTitle: 'Ocurrió un error',
    closeButton: 'Cerrar',
    geolocationUnsupportedError: 'Tu navegador no soporta geolocalización.',
    geolocationPermissionError:
      'No se pudo obtener tu ubicación. Revisa los permisos.',
    searchNoResultsError:
      'No se encontraron resultados. Intenta con otra dirección.',
    searchLocationError: 'Error al buscar la ubicación.',
    registerFallbackError: 'Ocurrió un error al registrar. Intenta de nuevo.',
    usernameTakenError: 'El nombre de usuario ya está en uso.',
    emailTakenError: 'El correo ya está registrado.',
    phoneTakenError: 'El número de celular ya está registrado.',
    emailAlreadyUserError:
      'Este correo ya está registrado como usuario de Parkit. Para ser socio debes usar un correo diferente al de tu cuenta de usuario.',
    usernameAlreadyUserError:
      'Este nombre de usuario ya está registrado como usuario de Parkit. Para ser socio debes usar uno diferente al de tu cuenta de usuario.',
    phoneAlreadyUserError:
      'Este número de celular ya está registrado como usuario de Parkit. Para ser socio debes usar un número diferente al de tu cuenta de usuario.',
    usernameRequiredBackendError: 'El nombre de usuario es requerido.',
    emailRequiredBackendError: 'El correo es requerido.',
    phoneRequiredBackendError: 'El teléfono es requerido.',
    passwordRequiredBackendError: 'La contraseña es requerida.',
    spaceTypeRequiredBackendError: 'El tipo de espacio es requerido.',
    capacityRequiredBackendError: 'La capacidad es requerida.',
    addressRequiredBackendError: 'La dirección es requerida.',
    latitudeRequiredBackendError: 'La latitud es requerida.',
    longitudeRequiredBackendError: 'La longitud es requerida.',
  },
  partnerDashboard: {
    pageTitle: 'Panel de socio',
    languageDialogTitle: 'Selecciona el idioma que deseas cambiar:',
    langSpanish: 'Español',
    langEnglish: 'English',
    changeLang: 'Change language',
    logoutButton: 'Salir',
    lightboxAlt: 'Vista ampliada',
    welcomeTitlePrefix: '¡Bienvenido,',
    welcomeTitleSuffix: '!',
    welcomeSubtitle:
      'Este es tu panel de socio Parkit. Aquí puedes gestionar tu cuenta y espacio.',
    refreshButton: 'Actualizar',
    refreshLoading: 'Actualizando...',
    refreshErrorFallback: 'No se pudo actualizar la información.',
    badges: {
      incomplete: 'Registro incompleto',
      review: 'En revisión',
      active: 'Cuenta activa',
    },
    step2Banner: {
      title: 'Completa tu registro - Paso 2 de 2',
      description:
        'Para activar tu cuenta necesitamos verificar que eres el propietario o representante del espacio. Solo toma unos minutos.',
      button: 'Continuar verificación',
    },
    reviewBanner: {
      title: 'Tu documentación está en revisión',
      description:
        'Nuestro equipo está verificando la información que enviaste. Te notificaremos por correo cuando tu cuenta sea activada',
    },
    progress: {
      title: 'Estado del registro',
      stepOne: {
        title: 'Paso 1',
        label: 'Registro de cuenta',
        detail: 'Cuenta creada exitosamente.',
      },
      stepTwo: {
        title: 'Paso 2',
        label: 'Verificación de propiedad',
        detailPending: 'Pendiente - envía tus documentos.',
        detailReview: 'En revisión por nuestro equipo.',
        detailApproved: 'Verificación aprobada.',
      },
      stepThree: {
        title: 'Paso 3',
        label: 'Cuenta activa',
        detailPending: 'Disponible al completar la verificación.',
        detailDone: '¡Tu cuenta está activa!',
      },
    },
    accountCard: {
      title: 'Datos de cuenta',
      username: 'Usuario',
      email: 'Correo',
      phone: 'Teléfono',
      status: 'Estado',
    },
    statusValues: {
      pendiente: 'Pendiente',
      activo: 'Activo',
      rechazado: 'Rechazado',
    },
    spaceCard: {
      title: 'Tu espacio',
      name: 'Nombre',
      type: 'Tipo',
      capacity: 'Capacidad',
      capacityUnit: 'lugares',
      zones: 'Zonas',
      address: 'Dirección',
      photos: 'Fotos del espacio',
      parkingPhoto: 'Estacionamiento',
      mapPhoto: 'Mapa',
    },
    verificationCard: {
      title: 'Verificación de identidad',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      idType: 'Identificación',
      idNumber: 'Número',
      propertyDocType: 'Documento',
      propertyDocReference: 'Folio',
      documents: 'Documentos adjuntos',
      idFront: 'ID Frente',
      idBack: 'ID Reverso',
      propertyDoc: 'Doc. Inmueble',
    },
    bottomCta: {
      text: '¿Listo para continuar? El paso 2 solo toma unos minutos.',
      button: 'Enviar mis documentos',
    },
    spaceTypeLabels: {
      terreno: 'Terreno',
      estacionamiento: 'Estacionamiento',
      plaza_comercial: 'Plaza comercial',
    },
    idTypeLabels: {
      ine: 'INE / IFE',
      pasaporte: 'Pasaporte',
      cedula: 'Cédula profesional',
      otro: 'Otro',
    },
    propertyDocTypeLabels: {
      escritura: 'Escritura pública',
      contrato_arrendamiento: 'Contrato de arrendamiento',
      titulo_propiedad: 'Título de propiedad',
      otro: 'Otro',
    },
  },
  changeProfile: {
    pageTitle: 'Editar perfil',
    cardSubtitle: 'Actualiza tus datos de contacto y tu contraseña.',
    cancelButton: 'Cancelar',
    emailLabel: 'Correo electrónico:',
    emailPlaceholder: 'test@test.com',
    nameLabel: 'Nombre:',
    namePlaceholder: 'userTT',
    phoneLabel: 'Teléfono:',
    phonePlaceholder: '55 2557 8634',
    phoneLockedHint: 'Tu teléfono no se puede editar porque fue el método con el que creaste tu cuenta.',
    passwordLabel: 'Contraseña:',
    passwordPlaceholder: '123456',
    confirmPasswordLabel: 'Repetir contraseña:',
    confirmPasswordPlaceholder: '123456',
    submitButton: 'Editar',
    logoAlt: 'Logo de Parkit',
    successModalTitle: 'Confirmación',
    successModalMessage: '¡Perfil actualizado correctamente!',
    successModalButton: 'Continuar',
    warningModalTitle: 'Ops!!!!!',
    warningModalButton: 'Continuar',
    passwordMismatchError: 'Las contraseñas no coinciden',
    passwordFormatError:
      'La contraseña debe incluir por lo menos una mayúscula, una minúscula, un carácter especial y un número',
    emailRequiredError: 'Debes agregar un correo válido.',
    emailInvalidError: 'Ingresa un correo válido.',
    nameRequiredError: 'El nombre de usuario es requerido.',
    nameMinLengthError: 'Mínimo 5 caracteres.',
    phoneRequiredError: 'El teléfono es requerido.',
  },
  changePass: {
    pageTitle: 'Cambiar contraseña',
    cancelButton: 'Cancelar',
    emailLabel: 'Correo electrónico:',
    emailPlaceholder: 'test@test.com',
    currentPasswordLabel: 'Contraseña actual:',
    currentPasswordPlaceholder: '123456',
    newPasswordLabel: 'Nueva contraseña:',
    newPasswordPlaceholder: '123456',
    confirmPasswordLabel: 'Repetir contraseña:',
    confirmPasswordPlaceholder: '123456',
    submitButton: 'Cambiar',
    logoAlt: 'Logo de Parkit',
    successModalTitle: 'Confirmación',
    successModalMessage: '¡Contraseña cambiada correctamente!',
    successModalButton: 'Continuar',
    warningModalTitle: 'Ops!!!!!',
    warningModalButton: 'Continuar',
    passwordMismatchError: 'Las contraseñas no coinciden',
    passwordFormatError:
      'La contraseña debe incluir por lo menos una mayúscula, una minúscula, un carácter especial y un número',
  },
  register: {
    pageTitle: 'Crear cuenta',
    cardTitle: 'Crear cuenta',
    cardSubtitle: 'Completa los datos para registrarte',
    usernameLabel: 'Nombre de usuario',
    usernamePlaceholder: 'Tu nombre de usuario',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tucorreo@ejemplo.com',
    phoneLabel: 'Número de celular',
    phonePlaceholder: '10 dígitos',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    confirmPasswordLabel: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repite tu contraseña',
    submitBtn: 'Registrar cuenta',
    backBtn: 'Regresar al inicio de sesión',
    helpLink: '¿Tienes dudas? Da clic aquí',
    inputRequired: 'Este campo es requerido',
    validNameRequired: 'Mínimo 5 caracteres',
    validEmailRequired: 'Ingresa un correo válido',
    phoneMinLength: 'El celular debe tener 10 dígitos',
    passwordMinLength: 'Mínimo 6 caracteres',
    validationRequired: 'Debes seleccionar una opción',
    passwordsMismatch: 'Las contraseñas no coinciden',
    passwordFormatError: 'La contraseña debe incluir al menos una mayúscula, una minúscula, un carácter especial y un número',
    modalSuccessTitle: '¡Cuenta creada!',
    modalSuccessMessage: 'Tu cuenta se ha creado correctamente. Para continuar, inicia sesión.',
    modalSuccessBtn: 'Continuar',
    modalErrorTitle: 'Atención',
    modalErrorBtn: 'Continuar',
    modeNormalBtn: 'Registro normal',
    modePhoneBtn: 'Registrar con teléfono',
    phoneRegisterSubtitle: 'Ingresa tu número y te enviaremos un código por WhatsApp para crear tu cuenta.',
    phoneRegisterBtn: 'Enviar código',
    phoneRequiredError: 'Debes agregar un número celular válido.',
    phonePatternError: 'El número de celular debe tener 10 dígitos.',
    phoneCodeTitle: 'Verificación',
    phoneCodeSubtitle: 'Introduce el código enviado a tu WhatsApp',
    verifyCodeRequired: 'Debes ingresar el código completo.',
    verifyBtn: 'Verificar código',
    phoneGenericError: 'Ocurrió un error, vuelve a intentarlo por favor.',
    profileTitle: 'Completa tu perfil',
    profileSubtitle: 'Solo necesitamos tu nombre y apellido para terminar.',
    firstNameLabel: 'Nombre',
    firstNamePlaceholder: 'Tu nombre',
    lastNameLabel: 'Apellido',
    lastNamePlaceholder: 'Tu apellido',
    emailOptionalLabel: 'Correo electrónico (opcional)',
    submitProfileBtn: 'Finalizar registro',
    cancelBtn: 'Cancelar',
    confirmCancelTitle: '¿Cancelar registro?',
    confirmCancelMessage: '¿Estás seguro de que deseas cancelar el registro? Perderás el progreso.',
    confirmCancelYesBtn: 'Sí, cancelar registro',
    confirmCancelNoBtn: 'No, continuar registro',
  },
  recover: {
    alertTitle: 'No se pudo recuperar la contraseña',
    alertClose: 'Cerrar',
    recoveryError: 'No se pudo enviar la solicitud. Inténtalo de nuevo.',
    pageTitle: 'Recuperar contraseña',
    cardTitle: 'Recuperar contraseña',
    cardSubtitle: 'Ingresa tu correo y te enviaremos las instrucciones para restablecer tu acceso.',
    emailLabel: 'Correo electrónico',
    emailPlaceholder: 'tucorreo@ejemplo.com',
    emailRequiredError: 'Debes agregar un correo válido',
    submitBtn: 'Enviar instrucciones',
    backBtn: 'Regresar al inicio de sesión',
    modalSuccessTitle: '¡Correo enviado!',
    modalSuccessMessage: 'Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.',
    modalSuccessBtn: 'Continuar',
    whatsappCountdownPrefix: '¿No recibiste el correo? intenta enviarlo a whats app en ',
    whatsappCountdownSuffix: ' segundos',
    whatsappLink: '¿No recibiste el correo? intenta enviarlo a whats app dando click aquí',
    whatsappSuccess: 'Se ha enviado tu nueva contraseña por WhatsApp.',
  },
  termsAndConditions: {
    pageTitle: 'Términos y condiciones',
    title: 'TÉRMINOS Y CONDICIONES (“ACUERDO”)',
    logoAlt: 'Logo de Parkit',
  },
  scanParking: {
    pageTitle: 'Escanear recinto',
    successTitle: '¡Bienvenido!',
    successMessage: 'Gracias por usar Parkit, tu boleto ha sido escaneado con éxito.',
    continueButton: 'Continuar',
    walletModalTitle: 'Atención',
    walletMissingTitle: 'Actualmente no cuentas con wallet de prepago.',
    walletMissingQuestion: '¿Deseas generar uno nuevo?',
    cancelButton: 'Cancelar',
    generateWalletButton: 'Sí, generar',
    entryScanButton: 'Escanear recinto entrada',
    readyToScanTitle: 'Listo para escanear',
    readyToScanDescription: 'Coloca el código QR dentro del marco para escanear automáticamente',
    scanEnclosureButton: 'Escanear recinto',
    exitScanButton: 'Escanear recinto salida',
    scanCodeTitle: 'Escanear código',
    cameraLabel: 'Selecciona cámara:',
    unknownCameraLabel: 'Cámara desconocida',
    detailTitle: 'Detalle',
    accessToLabel: 'Acceso a:',
    entryDateLabel: 'Fecha de entrada:',
    entryTimeLabel: 'Hora de entrada:',
    elapsedTimeLabel: 'Tiempo transcurrido',
    hoursLabel: 'Horas',
    minutesLabel: 'Minutos',
    secondsLabel: 'Segundos',
    walletButton: 'Wallet',
    enclosureTitle: 'Recinto',
    enclosureImageAlt: 'Foto del recinto',
    balanceLabel: 'SALDO:',
    noBalanceWarning:
      'Estimado usuario, si no cuentas con saldo, no podrás salir del recinto.',
    addBalanceButton: 'Agregar saldo',
    rechargeBalanceTitle: 'Recargar saldo',
    parkitLogoAlt: 'Logo de Parkit',
    emailLabel: 'Correo electrónico:',
    balanceToLoadLabel: 'Saldo a cargar:',
    goToPaymentButton: 'Ir al pago',
    acceptButton: 'Aceptar',
    errorTitle: 'Error',
    confirmationTitle: 'Confirmación',
    noBalanceError: 'No cuentas con saldo, necesitas recargar.',
    balanceRequiredError: 'Debes ingresar el saldo',
  },
  paymentFlow: {
    pageTitleCardPayment: 'Datos de la tarjeta',
    pageTitlePaymentSummary: 'Resumen de compra',
    pageTitlePaymentFinish: 'Confirmación de pago',
    pageTitlePaymentError: 'Falló la transacción',
    pageTitlePaymentPending: 'QR pendiente de pago',
    pageTitleOpenpaySuccess: 'Confirmación de pago',
    paymentMethodsTitle: 'Métodos de pago',
    timeToFinishPrefix: 'Dispones de',
    timeToFinishSuffix: 'para finalizar tu compra',
    selectPaymentMethod: 'Selecciona un método de pago:',
    totalToPay: 'Total a pagar',
    purchaseSummaryTitle: 'Resumen de compra',
    productsLabel: 'Productos',
    subtotalLabel: 'Subtotal',
    serviceChargeLabel: 'Cargo por servicio',
    discountCodePlaceholder: 'Código de descuento',
    appliedCodeLabel: 'Código aplicado:',
    applyButton: 'Aplicar',
    ticketCostLabel: 'Costo boleto:',
    previousCostLabel: 'Costo anterior:',
    removeTicketButton: 'Eliminar boleto',
    emptyCartButton: 'Vaciar carrito',
    cardThroughLabel: 'Tarjeta de crédito / débito a través de',
    mercadoPagoTitle: 'Pago con la plataforma de Mercado Pago',
    unsupportedCardsWarning:
      '*** No se acepta el pago con tarjetas American Express y CARNET',
    holderNameLabel: 'Nombre del titular:',
    holderLastNameLabel: 'Apellido del titular:',
    cardNumberLabel: 'Número de tarjeta:',
    cvvLabel: 'CVV:',
    cvvCvcLabel: 'CVV / CVC:',
    tipMonthYear:
      'TIP: Usa dos dígitos para el mes y dos dígitos para el año.',
    expiryMonthLabel: 'Mes de expiración:',
    expiryYearLabel: 'Año de expiración:',
    waitingValidationNote:
      'Debe esperar algunos segundos después de realizar la compra para que su banco haga la validación de sus datos y ésta se autorice.',
    followInstructionsNote: 'Favor de seguir las instrucciones.',
    changePaymentMethodButton: 'Cambiar método de pago',
    buyNowButton: 'Comprar ahora',
    cashAccreditationNote:
      'Cualquier medio de pago en efectivo se acreditará en menos de 1 hora.',
    paymentDueNote:
      'Tenga en cuenta que solo dispone de un par de días para realizar el pago, al transcurrir este período, el boleto se liberará y el código de barras no será válido.',
    purchaseDetailTitle: 'Detalle de compra',
    venueLabel: 'Recinto:',
    eventLabel: 'Evento:',
    dateLabel: 'Fecha:',
    descriptionLabel: 'Descripción:',
    selectedZoneLabel: 'Zona elegida:',
    goToPaymentButton: 'Ir al pago',
    cancelButton: 'Cancelar',
    continueButton: 'Continuar',
    sendButton: 'Enviar',
    acceptButton: 'Aceptar',
    exitButton: 'Salir',
    payButton: 'Pagar',
    closeButton: 'Cerrar',
    yesAcceptButton: 'Sí, aceptar',
    noButton: 'No',
    confirmationTitle: 'Confirmación',
    oopsTitle: 'Oops!',
    errorTitle: 'Error',
    helloPrefix: '¡Hola',
    referenceNumberLabel: 'Este es su número de referencia:',
    orderIdLabel: 'Este es su ID de pedido:',
    brandTagline: '¡Más satisfacción, mejores experiencias!',
    paymentCouldNotBeCompleted: 'El pago no se ha podido completar,',
    tryAgainOrContactBank:
      'Te sugerimos intentarlo de nuevo o contactar a tu banco.',
    mercadoPagoExtraChargePrefix:
      'Al seleccionar Mercado Pago como forma de pago, se agregará un cargo extra de',
    mercadoPagoExtraChargeSuffix: 'pesos.',
    agreeQuestion: '¿Estás de acuerdo?',
    ticketPurchasedSuccess: '¡Boleto comprado con éxito!',
    amountCoveredPrefix: 'El monto por',
    amountCoveredSuffix:
      'ha sido cubierto satisfactoriamente, gracias por su compra.',
    continueToEmailPrefix: 'De clic en continuar para enviar a su correo',
    continueToEmailCodeSuffix: 'su código.',
    continueToEmailQrSuffix: 'su código QR.',
    mercadoPagoPurchaseMessage:
      'Gracias por su compra, el boleto fue adquirido con Mercado Pago.',
    paymentOccurredErrorTitle: '¡Ha ocurrido un error!',
    paymentErrorTitle: '¡El pago no se ha podido completar!',
    paymentErrorReason:
      'debido a que no nos pudimos conectar con su banco, inténtelo de nuevo.',
    contactBankSuggestion:
      'Si cree que se trata de un error le sugerimos contactar a su banco.',
    pendingPaymentTitle: '¡Boleto en espera de pago!',
    pendingInstructionsPrefix:
      "Haga clic en 'Enviar' para enviar a su correo",
    pendingInstructionsSuffix:
      'el enlace con los datos para cubrir el pago.',
    pendingWaitMessage:
      'Si ya ha realizado el pago, espere aproximadamente una hora para que éste se pueda ver reflejado en el sistema.',
    openpaySuccessTitle: 'Pago exitoso',
    openpaySuccessMessage:
      'Estimado usuario, su pago se ha realizado correctamente, gracias por su compra.',
    openpayReferenceNumberLabel: 'Número de referencia:',
    openpayErrorTitle: 'Error de pago',
    openpayErrorMessage:
      'Lo sentimos, ha ocurrido un error al procesar su pago, favor de ponerse en contacto con su banco.',
    genericValidationError:
      'Lo sentimos ha ocurrido un error, favor de validar los datos.',
    holderNameRequired: 'El nombre del titular es requerido.',
    holderLastNameRequired: 'El apellido del titular es requerido.',
    cardNumberRequired: 'El número de tarjeta es requerido.',
    cvvRequired: 'El CVV es requerido.',
    cvvPattern: 'Debes ingresar el código CVV en 3 o 4 dígitos',
    monthRequired: 'El mes es requerido.',
    monthPattern: 'Debes ingresar un número entre 01 y 12',
    yearExpired: 'El año ingresado ya pasó.',
    yearRequired: 'El año es requerido.',
    yearPattern: 'Debes ingresar el año en dos dígitos',
    discountCodeValidMessage: 'El código que se ha ingresado es válido.',
    timeLimitExpiredMessage:
      'El límite de tiempo da la oportunidad a todos los usuarios a conseguir boletos.',
    cardExpiredReason: 'porque tu tarjeta ya venció',
    declinedInvalidMerchantReason:
      'porque la transacción se rechazó porque no era válida o no estaba habilitada para el comerciante.',
    declinedCardAccountNotFoundReason:
      'porque la transacción ha sido rechazada porque no existe tal cuenta de tarjeta de crédito.',
    declinedIssuerNotFoundReason:
      'porque no se ha encontrado un emisor relacionado con este número de tarjeta.',
    declinedInsufficientFundsReason:
      'porque la cuenta del titular de la tarjeta no tiene fondos suficientes para cubrir el monto de la transacción. Los intentos posteriores en una fecha posterior pueden tener éxito.',
    contactBankReason:
      'si crees que se trata de un error, te sugerimos contactar a tu banco',
    ticketPurchaseDescription: 'Compra de boleto',
    ticketForEventPrefix: 'Boleto para el evento:',
    eventCanceledSuccess: '¡Evento cancelado con éxito!',
  },
  userPaySubscribe: {
    pageTitle: 'Resumen de recarga',
    subscriberAmountTitle: 'Abonado - Monto a pagar:',
    selectPaymentMethod: 'Selecciona un método de pago:',
    helloPrefix: '¡Hola',
    paymentCouldNotBeCompleted: 'El pago no se ha podido completar,',
    brandTagline: '¡Más satisfacción, mejores experiencias!',
    acceptButton: 'Aceptar',
    subscriberPurchasedSuccess: '¡Abonado comprado con éxito!',
    amountCoveredPrefix: 'El monto por',
    amountCoveredSuffix: 'ha sido cubierto satisfactoriamente, gracias por su compra.',
    referenceNumberLabel: 'Este es su número de referencia:',
    continueButton: 'Continuar',
    errorTitle: 'Error',
    contactBankSuggestion: 'si crees que se trata de un error, te sugerimos contactar a tu banco',
    cardExpiredReason: 'porque tu tarjeta ya venció',
  },
  vehicles: {
    pageTitle: 'Mis vehículos',
    title: 'Mis vehículos',
    subtitle: 'Administra los vehículos que utilizas para ingresar al estacionamiento.',
    addVehicle: 'Agregar vehículo',
    registeredVehiclesTitle: 'Vehículos registrados',
    noRegisteredVehiclesTitle: 'Aún no tienes vehículos registrados',
    noRegisteredVehiclesMessage: 'Agrega tu primer vehículo para tener preparados sus datos de acceso al estacionamiento.',
    addFirstVehicle: 'Agregar mi primer vehículo',
    registrationEyebrow: 'Nuevo vehículo',
    registrationTitle: 'Completa los datos de tu vehículo',
    registrationHelp: 'Selecciona la marca y modelo que correspondan a tu vehículo.',
    edit: 'Editar',
    editVehicle: 'Editar vehículo',
    editVehicleEyebrow: 'Editar vehículo',
    editVehicleTitle: 'Actualiza los datos de tu vehículo',
    editVehicleHelp: 'Modifica los datos que necesites y guarda los cambios.',
    country: 'País',
    state: 'Estado',
    brand: 'Marca',
    model: 'Modelo',
    color: 'Color',
    licensePlate: 'Placas',
    selectState: 'Selecciona un estado',
    selectBrand: 'Selecciona una marca',
    selectModel: 'Selecciona un modelo',
    selectColor: 'Selecciona un color',
    loadingCatalog: 'Cargando marcas...',
    licensePlatePlaceholder: 'Ej. ABC-123-A',
    saveVehicle: 'Guardar vehículo',
    cancel: 'Cancelar',
    close: 'Cerrar',
    catalogError: 'No fue posible cargar las marcas y modelos.',
    retry: 'Reintentar',
    savingVehicle: 'Guardando tu vehículo...',
    updatingVehicle: 'Actualizando tu vehículo...',
    updateVehicle: 'Guardar cambios',
    registrationError: 'No fue posible guardar tu vehículo. Intenta nuevamente.',
  },
  userTickets: {
    pageTitle: 'Mis Eventos',
    loadingText: 'Cargando Boletos',
    loadingSpinnerSr: 'Cargando...',
    sectionTitle: 'Mis Boletos',
    filterAll: 'Todos',
    filterEvent: 'Evento',
    filterBus: 'Autobús',
    searchPlaceholder: 'Buscar por evento, recinto o fecha…',
    statusAll: 'Todos',
    statusLabel: 'ESTATUS:',
    statusActive: 'Activos',
    statusBurned: 'Quemados',
    subfilterAll: 'Todos',
    subfilterIda: 'Ida',
    subfilterVuelta: 'Vuelta',
    legendIda: 'BOLETO DE IDA',
    legendVuelta: 'BOLETO DE VUELTA',
    legendEvent: 'BOLETO DE ESTACIONAMIENTO',
    travelCodeLabel: 'CÓDIGO DE VIAJE:',
    legendIdaShort: 'Ida',
    legendVueltaShort: 'Vuelta',
    legendParkingShort: 'Estacionamiento',
    ticketCapBus: 'BOLETO DE AUTOBUS',
    ticketCapEvent: 'BOLETO DE EVENTO',
    viewQr: 'Ver QR',
    ticketTypeBusPrefix: 'AUTOBUS',
    ticketTypeEvent: 'ACCESO AL ESTACIONAMIENTO',
    eventEyebrow: 'EVENTO:',
    purchasedAtLabel: 'Boleto comprado en el recinto:',
    labelDate: 'Fecha',
    labelBusSchedule: 'Horario de Autobús',
    labelZone: 'Zona',
    labelHora: 'Hora',
    labelHorarioIda: 'Horario Ida',
    labelHorarioRegreso: 'Horario Regreso',
    labelDescription: 'Descripción',
    validTrip: 'Este boleto es válido para el viaje:',
    ticketUsed: 'Este boleto ya ha sido utilizado',
    usedHourLabel: 'Hora:',
    usedDateLabel: 'Fecha:',
    usedByLabel: 'Por:',
    useTicketBtn: 'Usar boleto',
    statusBurnedBadge: 'Quemado',
    statusActiveBadge: 'Activo',
    qrValid: 'QR Válido',
    qrExpired: 'QR Vencido',
    qrPending: 'Pendiente de confirmación de pago',
    ticketTypeBusModal: 'BOLETO DE AUTOBÚS',
    ticketTypeEventModal: 'BOLETO DE ESTACIONAMIENTO',
    closeBtn: 'Cerrar',
    downloadBtn: 'Descargar PNG',
    pendingNote: 'Una vez reflejado el pago podrás descargar tu QR',
    emptyTitle: 'Aún no tienes boletos',
    emptyDesc1: 'Cuando adquieras un boleto aparecerá aquí.',
    emptyDesc2: 'Explora los eventos disponibles y reserva tu lugar.',
    emptyStep1: 'Elige tu ciudad',
    emptyStep2: 'Selecciona recinto',
    emptyStep3: 'Compra tu boleto',
    exploreBtn: 'Explorar eventos',
    backBtn: 'Regresar',
    alertTitle: 'Aviso',
    alertMessage: 'Aún no cuentas con boletos para este recinto',
    cancelBtn: 'Cancelar',
    confirmTitle: 'Confirmación',
    confirmMessagePrefix: '¿Esta seguro de que quiere usar su boleto de:',
    acceptBtn: 'Aceptar',
    downloadDisclaimer: 'Boleto digital · No comparta este código QR',
    downloadZoneLabel: 'Zona:',
  },
} as const;
